import AOS from 'aos';
import './table';
import './modal';

AOS.init({
  duration: 600,
  easing: 'ease-in-out-sine',
});

// ensure any userform 'action_process' buttons have the 'button button--primary'
// classes added
document.querySelectorAll('input[name=action_process]').forEach((el) => {
  el.classList.add('button');
  el.classList.add('button--primary');
});

document
  .querySelectorAll('[data-click-feature-card] .feature-card')
  .forEach((el) => {
    // add a javascript handler to the feature card in certain cases when we
    // want a click anywhere on the card (i.e the image) to trigger the link
    el.addEventListener('click', () => {
      const featureCardLink = el.querySelector('a');

      if (featureCardLink) {
        window.location.href = featureCardLink.getAttribute('href');
      }
    });
  });

// wrap all .rte-button elements in a span so we can style them
document.querySelectorAll('.rte-button').forEach((el) => {
  const wrapper = document.createElement('span');
  wrapper.classList.add('rte-button-wrapper');
  el.parentNode.insertBefore(wrapper, el);
  wrapper.appendChild(el);

  // find a `.button__circle` on the page and append the same markup to the
  // rte button
  const buttonCircle = document.querySelector('.button__circle');
  if (buttonCircle) {
    const buttonCircleClone = buttonCircle.cloneNode(true);
    el.appendChild(buttonCircleClone);
  }
});

document.querySelectorAll('.enquiry-type input').forEach((el) => {
  el.addEventListener('change', () => {
    // if this val, then show the form
    const form = el.closest('form');
    let enquiryType = el.value;

    // hide all forms
    if (enquiryType) {
      // update the url with the enquiry type
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('enquiry', enquiryType);

      const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
      window.history.pushState({}, '', newUrl);

      // make sure the .btn-toolbar .Action has a button class
      const btnToolbarAction = form.querySelector('.btn-toolbar .action');
      if (btnToolbarAction) {
        btnToolbarAction.classList.add('button');
        btnToolbarAction.classList.add('button--primary');
      }

      form.classList.add('progress');

      // focus the first input in the form
      const firstInput = form.querySelector('input.text');
      if (firstInput) {
        firstInput.focus();
      }

      // add the Related articles from the help centre if we haven't
      if (!window.ALGOLIA_SHOW_HELP) {
        form.scrollIntoView({
          behavior: 'smooth',
        });

        return;
      }

      let helpArticles = document.querySelector('.related-help-articles');

      if (!helpArticles) {
        // add the related articles after `.enquiry-type``
        const enquiryDiv = document.querySelector('.enquiry-type');

        helpArticles = document.createElement('div');

        helpArticles.innerHTML =
          '<p>Related articles from the help centre:</p><ol></ol>';
        helpArticles.classList.add('related-help-articles');

        // add help articles after enquiry type
        enquiryDiv.insertAdjacentElement('afterend', helpArticles);
      }

      helpArticles.classList.add('loading');

      // scroll helpArticles into view
      form.scrollIntoView({
        behavior: 'smooth',
      });

      // fetch related articles
      let currentPageUrl = window.location.href;

      // remove any query params
      currentPageUrl = currentPageUrl.split('?')[0];

      // url encode the enquiry type
      enquiryType = encodeURIComponent(enquiryType);
      fetch(`${currentPageUrl}/relatedHelpArticles?type=${enquiryType}`)
        .then((response) => response.json())
        .then((results) => {
          // clear all li items in helpArticles
          helpArticles.querySelector('ol').innerHTML = '';

          // if results then add as list items
          if (results.length > 0) {
            const html = results
              .map(
                (result) =>
                  `<li><a href="${result.link}">${result.title}</a></li>`,
              )
              .join('');
            helpArticles.querySelector('ol').innerHTML = html;
          } else {
            helpArticles.querySelector('ol').innerHTML =
              '<li>No related articles found at this time.</li>';
          }

          helpArticles.classList.remove('loading');
        });
    } else {
      form.classList.remove('progress');
    }
  });
});

// if a enquiry-type is selected, then trigger the change event
const enquiryType = document.querySelector('.enquiry-type input:checked');
if (enquiryType) {
  enquiryType.dispatchEvent(new Event('change'));
}

// on popstate, if the enquiry type is selected, then trigger the change event
window.addEventListener('popstate', () => {
  const enquiryType = document.querySelector('.enquiry-type input:checked');
  if (enquiryType) {
    enquiryType.dispatchEvent(new Event('change'));
  }
});

// if the url params has an enquiryType, then select the radio button which matches
const urlParams = new URLSearchParams(window.location.search);
const enquiryTypeParam = urlParams.get('enquiry');

if (enquiryTypeParam) {
  const enquiryTypeRadio = document.querySelector(
    `.enquiry-type input[value="${enquiryTypeParam}"]`,
  );

  if (enquiryTypeRadio) {
    enquiryTypeRadio.checked = true;
    enquiryTypeRadio.dispatchEvent(new Event('change'));
  }
}
